import { Box, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdCreate, MdInfoOutline, MdOutlineArrowRightAlt, MdOutlineDone, MdOutlineTimer, MdOutlineVerified, MdReportGmailerrorred } from 'react-icons/md';

export default class DadosInventario extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados, disabled, inicio, final } = this.props;
        let delayed = dados?.duracaoInt > dados?.meta;

        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                        <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" justifyItems="center" gap={1} p={1.2}>
                            <MdInfoOutline />
                            <Typography variant="caption"><b>INFORMAÇÕES DO INVENTÁRIO</b></Typography>
                            <Box flex={1.0} />
                            {/* {!disabled && <Box title="Editar este resultado" mt={-0.8}><IconButton ><MdCreate color="#0A57A3" size={15} /></IconButton></Box>} */}
                        </Stack>
                        <Stack alignItems="center" p={2} direction="row" gap={2} color="#606060">
                            <Box>
                                <Typography fontSize={11}>INVENTÁRIO ANTERIOR</Typography>
                                <Typography fontSize={10}><b>{inicio}</b></Typography>
                            </Box>

                            <Box width="1px" height="40px" bgcolor="#c0c0c0" />

                            <Box>
                                <Typography fontSize={11}>INVENTÁRIO ATUAL</Typography>
                                <Typography fontSize={10}><b>{final}</b></Typography>
                            </Box>

                            <Box><MdOutlineArrowRightAlt size={20} /></Box>

                            <Box>
                                <Typography fontSize={11}>INÍCIO</Typography>
                                <Typography fontSize={10}><b>{dados?.horaInicio}</b></Typography>
                            </Box>

                            <Box>
                                <Typography fontSize={11}>TÉRMINO</Typography>
                                <Typography fontSize={10}><b>{dados?.horaTermino}</b></Typography>
                            </Box>

                            <Stack alignItems="center">
                                <Stack width={70} alignItems="center" justifyContent="center" p={1} bgcolor="#f8f9fa" color="#136188" borderRadius={2} border="1px solid #e5e7eb">
                                    <MdOutlineTimer size={20} />
                                    <Typography fontSize={11}>DURAÇÃO</Typography>
                                    <Typography fontSize={10}><b>{dados?.duracao}</b></Typography>
                                </Stack>
                                {delayed ?
                                    <Stack mt={-1.3} width={100} alignItems="center" justifyContent="center" p={0.2} direction="row" color="#801515" bgcolor="#fdf0f0" borderRadius={1} border="1px solid #f7bbbb">
                                        <Typography mr={0.3} fontSize={11}><b>Extrapolou</b></Typography>
                                        <MdReportGmailerrorred size={13} />
                                    </Stack>
                                    :
                                    <Stack mt={-1.3} width={100} justifyContent="center" alignItems="center" p={0.2} direction="row" color="#15803d" bgcolor="#f0fdf4" borderRadius={1} border="1px solid #bbf7d0">
                                        <Typography mr={0.3} fontSize={11}><b>Dentro da meta</b></Typography>
                                        <MdOutlineDone size={13} />
                                    </Stack>
                                }
                            </Stack>

                            <Box flex={1} />

                            {disabled && <Stack color="green">
                                <Box ml={1}><MdOutlineVerified size={50} /></Box>
                                <Typography><b>Apurado!</b></Typography>
                            </Stack>}

                        </Stack>
                    </Stack>
                }
            </>
        );
    }
}